<template>
  <div class="html-report-body">
    <iframe
      v-if="fileUrl"
      ref="iframeRef"
      sandbox="allow-scripts"
      :src="fileUrl"
      style="width: 100%; height: 100%; border: none"
    />
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { getCustomRecordInfo } from '@/api'
import emitter from '@/utils/mitt'
import xbbSdk from 'xbb-sdk'

defineOptions({
  name: 'HtmlReportBody'
})

const props = defineProps({
  panelData: {
    type: Object,
    default: () => ({})
  }
})

const iframeRef = ref(null)
const BUSINESS_DETAIL_CONFIG = {
  8000: {
    detailType: 'clue',
    idKey: 'clueId'
  },
  100: {
    detailType: 'customer',
    idKey: 'customerId'
  }
}

const fileUrl = computed(() => props.panelData.fileUrl || '')

const handleOpenAiDetail = (data = {}) => {
  const { businessDataId, businessType, behavingId } = data
  const config = BUSINESS_DETAIL_CONFIG[Number(businessType)]

  if (!config || !businessDataId) return

  emitter.emit('openAiDetailSplit', {
    deatilData: {
      id: behavingId,
      detailType: config.detailType,
      [config.idKey]: businessDataId
    }
  })
}

const handleOpenXbbDetail = async (data = {}) => {
  const { dataId, businessType } = data
  const res = await getCustomRecordInfo({ businessType })
  const { appId, subBusinessType } = res.result
  xbbSdk.sendMessage('openDetailPage', {
    appId: appId,
    dataId: dataId,
    saasMark: 1,
    businessType: businessType,
    subBusinessType: subBusinessType,
    uuid: xbbSdk.props.uuid
  })
}

const MESSAGE_HANDLERS = {
  // createDailyReport: handleCreate,
  // createWeeklyReport: handleCreate,
  openAiDetail: handleOpenAiDetail,
  openXbbDetail: handleOpenXbbDetail
}

const messageHandler = (event) => {
  console.log(event)
  if (event.source !== iframeRef.value?.contentWindow) return
  if (!event.data || typeof event.data !== 'object') return

  const { type, data } = event.data
  MESSAGE_HANDLERS[type]?.(data)
}

onMounted(() => {
  window.addEventListener('message', messageHandler)
})

onUnmounted(() => {
  window.removeEventListener('message', messageHandler)
})
</script>

<style lang="scss" scoped>
.html-report-body {
  width: 100%;
  height: 100%;
}
</style>
